import React from "react";

const StarHealthPolicy = () => {
  return (
    <div className="policy-container">
      <div className="policy-header">
        <h1>Star Health Assure Insurance Policy</h1>
        <div className="uin">UIN: SHAHLIP23131V022223</div>
        <div className="subhead">
          Covers hospitalization expenses incurred as a result of illness and/or accidental injuries
        </div>
      </div>

      <div className="table-wrapper">
        <table className="param-table">
          <tbody>
            <tr>
              <th>About the policy</th>
              <td>
                Covers hospitalization expenses incurred as a result of illness and/or accidental injuries
              </td>
            </tr>
            <tr>
              <th>Type of Cover</th>
              <td>Individual and Floater</td>
            </tr>
            <tr>
              <th>Entry Age</th>
              <td>
                <strong>Individual:</strong> Min 18 Years to Max 75 Years, Dependent Children: Min 91 Days to Max 17
                Years
                <br />
                <strong>Floater:</strong> Min 18 Years to Max 75 Years, Dependent Children: Min 16 Days to Max 17
                Years
                <br />
                <span className="note-text">
                  Note: In case of dependent children, at the time of renewal when they become 18 years of age, such
                  children will be considered as Adult and he/she can continue under floater sum insured till he/she
                  gets married
                </span>
              </td>
            </tr>
            <tr>
              <th>Maximum Family Size</th>
              <td>
                Maximum family size is 2A+3C+4P (Self, Spouse, Dependent children, Parents and Parents-in-law).
                <br />
                <strong>Or</strong> 6 Adults + 3 Children (6 Adults = Self + Spouse + Parents + Parents-in-law).
                <br />
                If Dependent parents and parents in-laws alone wants to cover under this policy separately, the same is
                possible under 2A family scheme.
              </td>
            </tr>
            <tr>
              <th>Midterm Inclusion</th>
              <td>
                Available for Newly Wedded spouse, New born baby and Legally adopted child. Intimation should be given
                within 45 days from the date of marriage or date of birth
              </td>
            </tr>
            <tr>
              <th>Zone based pricing</th>
              <td>
                <strong>Zone A:</strong> Delhi including Faridabad, Gurgaon, Ghaziabad and Noida, Mumbai including
                Thane, Ahmedabad, Surat and Vadodara
                <br />
                <strong>Zone B:</strong> Pune including Nashik, Trivandrum, Ernakulam, Chennai, Bengaluru, Hyderabad,
                Secunderabad and Rest of Gujarat
                <br />
                <strong>Zone C:</strong> Rest of India
              </td>
            </tr>
            <tr>
              <th>Co-payment</th>
              <td>
                10% of each and every claim amount for fresh as well as renewal policies for insured person whose age
                at the time of entry is 61 years and above.
              </td>
            </tr>
            <tr>
              <th>Renewal</th>
              <td>Lifelong</td>
            </tr>
            <tr>
              <th>Policy Term</th>
              <td>One Year, Two years & Three Years</td>
            </tr>
            <tr>
              <th>Long Term Discount</th>
              <td>
                Two year policy: 10% discount on 2<sup>nd</sup> year premium
                <br />
                Three year policy: 10% discount is available on 2<sup>nd</sup> and 3<sup>rd</sup> year premium
              </td>
            </tr>
            <tr>
              <th>Floater Discount</th>
              <td>
                For Child : 40% discount is available from 1A premium when he/she becomes 18 years at the time of
                renewal in floater policy
                <br />
                For Parent/Parent in law - 10% discount is available from 1A premium for each parent when they come
                under floater policy
              </td>
            </tr>
            <tr>
              <th>Pre Medical Screening</th>
              <td>
                For those who declare adverse medical history, company may subject them to undergo pre-policy medical
                check-up. 100% cost of such medical examination is borne by the company
                <br />
                <span className="note-text">
                  Note : For children whose age is less than 12 years, Paediatrician letter, Vaccination report or
                  Health Report should be submitted and the proposal will be routed to our CMU Team for medical
                  opinion.
                </span>
              </td>
            </tr>
            <tr>
              <th>Sum Insured Options (Rs. in Lakhs)</th>
              <td>
                <span className="si-list">5, 10, 15, 20, 25, 50, 75, 100, 200</span>
                <br />
                <span className="note-text">
                  Note: Rs 75 Lakhs, Rs 100 Lakhs and Rs 200 Lakhs sum insured will be available for persons aged up
                  to 65 years only. This is applicable only at the time of inception of this policy
                </span>
              </td>
            </tr>
            <tr>
              <th>Room Rent</th>
              <td>1% of SI Any Room (Except suite or above category) Any Room</td>
            </tr>
            <tr>
              <th>Coverage for Non Medical Items (Consumables)</th>
              <td>
                If there is an admissible claim under inpatient / day care the policy, then Items as per List I will
                become payable
              </td>
            </tr>
            <tr>
              <th>Emergency Road Ambulance</th>
              <td>
                Covered upto sum insured (i) for transportation to hospital (ii) from one hospital to other hospital
                (iii) from hospital to residence
              </td>
            </tr>
            <tr>
              <th>Pre & Post Hospitalization</th>
              <td>60 days & 180 days. Covered upto sum insured</td>
            </tr>
            <tr>
              <th>Organ Donor Expenses</th>
              <td>
                Covered upto sum insured. Additional SI up to Basic SI for the Complications (if any) that necessitate
                a Redo Surgery/ICU admission
              </td>
            </tr>
            <tr>
              <th>Day Care Treatments</th>
              <td>All day care treatments are covered upto sum insured</td>
            </tr>
            <tr>
              <th>Domiciliary hospitalization</th>
              <td>Covered upto sum insured. Treatment taken at home for the period exceeding three days</td>
            </tr>
            <tr>
              <th>Home Care Treatment</th>
              <td>Payable up to 10% of the sum insured subject to maximum of Rs 5 Lakhs in a policy year</td>
            </tr>
            <tr>
              <th>Air Ambulance</th>
              <td>Covered up to 10% of sum insured per policy year</td>
            </tr>
            <tr>
              <th>Star Wellness Program</th>
              <td>
                Available for Insured aged ≥ 18 yrs. Wellness platform available both in mobile app "Star Power" &
                Customer Portal (Retail).
                <br />
                The Insured can earn reward points and avail premium discount up to 20% on the renewal premium by
                enrolling and achieving the wellness goals. For details please refer the policy wording / prospectus.
              </td>
            </tr>

            <tr>
              <th>
                Health Check up (Assure Each policy year)
                <br />
                (Irrespective of claim)
              </th>
              <td>
                <strong>Individual (Rs):</strong> 1500 (5L) | 2000 (10L) | 4000 (15L) | 5000 (20L/25L/50L) | 8000
                (75L/100L/200L)
                <br />
                <strong>Floater (Rs):</strong> 2500 (5L) | 5000 (10L) | 8000 (15L) | 10000 (20L/25L/50L) | 15000
                (75L/100L/15000)
                <br />
                <span className="note-text">*As per SI slabs: 5L,10L,15L,20L,25L,50L,75L,100L,200L</span>
              </td>
            </tr>
            <tr>
              <th>Cumulative Bonus</th>
              <td>25% of sum insured for each claim free and maximum up to 100% of the sum insured</td>
            </tr>
            <tr>
              <th>Ayush Treatment (Ayurveda, Unani, Sidha & Homepathy)</th>
              <td>Covered up to sum insured</td>
            </tr>
            <tr>
              <th>Assisted Reproduction Treatment (Limit of Liability in a policy year)</th>
              <td>
                1 Lakh (SI 5L) | 2 Lakhs (SI 10L-25L) | 4 Lakhs (SI 50L-200L)
                <br />
                <span className="note-text">Exact: 5L→1L, 10/15/20/25L→2L, 50/75/100/200L→4L</span>
              </td>
            </tr>
            <tr>
              <th>Delivery Expenses (Per Policy Year)</th>
              <td>
                Covered up-to 10% of the Sum Insured. Both self and spouse are covered under this policy for a
                continuous period of 2 years under Individual or floater sum insured
              </td>
            </tr>
            <tr>
              <th>In Utero Fetal surgery/Intervention</th>
              <td>Covered up to sum insured, Waiting period: 2 years from the date of inception of this policy</td>
            </tr>
            <tr>
              <th>Hospitalization Expenses for Treatment of New Born Cover</th>
              <td>
                2 Lakhs (for SI 5L to 25L) | 4 Lakhs (for SI 50L to 200L)
                <br />
                <span className="note-text">
                  5L,10L,15L,20L,25L → 2 Lakhs; 50L,75L,100L,200L → 4 Lakhs
                </span>
              </td>
            </tr>
            <tr>
              <th>Treatment for Chronic Severe Refractory Asthma</th>
              <td>Payable up to 10% of sum insured not exceeding Rs.5 Lakhs per policy period</td>
            </tr>
            <tr>
              <th>Compassionate Travel</th>
              <td>
                Company will reimburse the transportation expenses by air incurred up to Rs.10,000/- for one immediate
                family member (other than the travel companion)
              </td>
            </tr>
            <tr>
              <th>Repatriation of mortal remains</th>
              <td>
                Company shall reimburse up to Rs.15,000/- in a policy year payable towards the cost of repatriation of
                mortal remains of the insured person (including the cost of embalming and coffin charges) to the
                residence of the Insured as recorded in the policy
              </td>
            </tr>
            <tr>
              <th>Treatment in Valuable Service Providers Network</th>
              <td>1% of Sum Insured subject to a maximum of Rs.5,000/- per policy period is payable as lumpsum</td>
            </tr>
            <tr>
              <th>Shared Accommodation</th>
              <td>
                Payable for in-patient hospitalization, then amount of Rs.1,000/- per day will be payable for each
                continuous and completed period of 24 hours of stay in such shared accommodation
              </td>
            </tr>
            <tr>
              <th>Second Medical Opinion</th>
              <td>
                Can obtain a Second Medical Opinion from a Doctor in the Company's network of Medical Practitioners.
                All medical records should be forwarded to the mail-id e_medicalopinion@starhealth.in or through
                Post/Courier.
              </td>
            </tr>
            <tr>
              <th>Automatic Restoration</th>
              <td>
                Sum Insured will be restored unlimited number of times and maximum up to 100% each time, which can be
                utilized for a subsequent hospitalization. Restoration will trigger immediately upon partial/full
                utilization of the sum insured.
                <br />
                On partial utilization → restored up to extent of utilization. On full utilization → restored to 100%.
                Used for all claims including modern treatment, but for a subsequent hospitalization. Maximum payable
                amount for a single claim under restoration benefit shall not more than the sum insured.
              </td>
            </tr>
            <tr>
              <th>Modern treatments</th>
              <td>Covered up to sum insured</td>
            </tr>
            <tr>
              <th>Rehabilitation and Pain Management</th>
              <td>
                Covered up to the sub-limit (or) maximum up to 20% of the sum insured whichever is less, per policy
                year
              </td>
            </tr>
            <tr>
              <th>Optional Cover (Deductible)</th>
              <td>
                This deductible is applicable for every policy year (on Aggregate basis)
                <br />
                <strong>Upto Rs 20 Lakhs SI:</strong> Rs 50,000 (45% discount) | Rs 1 Lakh (55% discount)
                <br />
                <strong>Above Rs 20 Lakhs SI:</strong> Rs 50,000 (35% discount) | Rs 1,00,000 (50% discount)
              </td>
            </tr>

            <tr className="section-title">
              <th colSpan="2">Waiting Periods</th>
            </tr>
            <tr>
              <th>Initial waiting period</th>
              <td>30 days for all illnesses (except accident)</td>
            </tr>
            <tr>
              <th>For Specific diseases</th>
              <td>2 years</td>
            </tr>
            <tr>
              <th>Pre-existing diseases</th>
              <td>
                Applicable for 3 year policy term: 2.5 years. Applicable for 1 year and 2 year policy term : 3 years
              </td>
            </tr>
            <tr>
              <th>Delivery Expenses Cover</th>
              <td>2 years</td>
            </tr>
            <tr>
              <th>In Utero Fetal Surgery / Intervention</th>
              <td>2 years</td>
            </tr>
            <tr>
              <th>Assisted Reproduction Treatment</th>
              <td>2 years</td>
            </tr>
            <tr>
              <th>New Born Baby Cover</th>
              <td>1 year</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StarHealthPolicy;


